type getTimestampMsFromTimeValuesArgs = {
  newTimeValues: TimeValues;
  currentTimestampMs: string | undefined | null;
};

type updateTimestampMsWithNewDateArgs = {
  newDateString: string;
  timestampMsToUpdate: string | undefined | null;
};

const dateTimeUtils = {
  // Time should be in format of "HH:MM am/pm"
  // parses time string, returns TimeValue object
  getTimeValuesFromTimestampMs: (formattedTimestampMs: string | undefined): TimeValues => {
    if (!formattedTimestampMs) {
      return {
        hour: '12',
        minute: '00',
        meridiem: 'am',
      };
    }

    const splitBySpace = formattedTimestampMs.split(' ');
    const splitByColon = splitBySpace[0].split(':');

    const hour = splitByColon[0];
    const minute = splitByColon[1];
    const meridiem = splitBySpace[1];

    return {
      hour,
      minute,
      meridiem,
    };
  },
  // Updates existing DateTime using new time values
  getTimestampMsFromTimeValues: ({ newTimeValues, currentTimestampMs }: getTimestampMsFromTimeValuesArgs): string => {
    const newDateObject = currentTimestampMs ? new Date(+currentTimestampMs) : new Date();
    const { hour, minute, meridiem } = newTimeValues;

    let newHour = hour;

    if (meridiem === 'pm') {
      if (hour != '12') {
        newHour = `${Number(hour) + 12}`;
      }
    } else {
      if (hour === '12') {
        newHour = '0';
      }
    }

    newDateObject.setHours(Number(newHour));
    newDateObject.setMinutes(Number(minute)); // 0 = Jan, 1 = Feb, etc.

    return `${newDateObject.getTime()}`;
  },
  updateTimestampMsWithNewDate: ({
    newDateString, // in format of MM/DD/YYYY
    timestampMsToUpdate,
  }: updateTimestampMsWithNewDateArgs): string => {
    const newDateObject = timestampMsToUpdate ? new Date(+timestampMsToUpdate) : new Date();
    const [month, day, year] = newDateString.split('/');

    if (year && !isNaN(Number(year))) {
      newDateObject.setFullYear(Number(year));
    }

    if (month && !isNaN(Number(month))) {
      newDateObject.setMonth(Number(month) - 1); // 0 = Jan, 1 = Feb, etc.
    }

    if (day && !isNaN(Number(day))) {
      newDateObject.setDate(Number(day));
    }

    const newTimeStamp = newDateObject.getTime();

    // Rare edge case, where this results in a NaN
    // Return empty string in this case and make user start over
    if (isNaN(newTimeStamp)) {
      return '';
    }

    return `${newTimeStamp}`;
  },
};

export default dateTimeUtils;
